import { render, staticRenderFns } from "./RecebimentosLista.vue?vue&type=template&id=4679ea0e&scoped=true&"
import script from "./RecebimentosLista.vue?vue&type=script&lang=js&"
export * from "./RecebimentosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679ea0e",
  null
  
)

export default component.exports